module.exports = __webpack_public_path__ + "img/baseline-search-light.10935d04.svg";